import userRoles from 'app/userRoles';
import React from 'react';

const LoyaltyConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [userRoles.ROLE_SUPER_ADMIN, userRoles.FRANCHISEE_DASHBOARD],
  routes: [
    {
      path: '/fidelity',
      exact: true,
      component: React.lazy(() => import('.'))
    }
  ]
};

export { LoyaltyConfig };
